import { RdoTableRow } from "./rdoOperacoes.types";

export type RdoDetailChartParams = {
  UnidadeId: string;
  SafraId: string;
  safraPeriodoId: string;
  operacaoClasseId: string;
  sequencia?: number;
  operacaoCalendarizada?: boolean;
};

export function buildRdoDetailChartParams(opts: {
  unidadeId: string;
  safraId: string;
  safraPeriodoId: string;
  row: RdoTableRow;
}): RdoDetailChartParams {
  const { unidadeId, safraId, safraPeriodoId, row } = opts;
  const base: RdoDetailChartParams = {
    UnidadeId: unidadeId,
    SafraId: safraId,
    safraPeriodoId,
    operacaoClasseId: row.operacaoClasseId,
  };
  if (!row.isParent && row.sequencia != null) {
    base.sequencia = row.sequencia;
    base.operacaoCalendarizada = row.operacaoCalendarizada;
  }
  return base;
}
